import { InvestProjectRate } from './invest-project-rate';

export class InvestProjectYear {
    year: number;
    loaningAmount: number;
    loaningTypeCode: string;
    rate: InvestProjectRate;

    constructor(year: number) {
        this.year = year;
        this.loaningAmount = 0;
        this.loaningTypeCode = null;
        this.rate = new InvestProjectRate();
    }
}
